import { render } from "./EditorResizeImageMobileDialog.vue?vue&type=template&id=094b228e"
import script from "./EditorResizeImageMobileDialog.vue?vue&type=script&lang=js"
export * from "./EditorResizeImageMobileDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__